import { connect } from 'react-redux';
import { get } from 'lodash';

import Title from '../components/partials/Title';
import { setModalVisibility } from '../actions/reviews';
import { isUserLoggedIn } from 'apps/user/helpers';

export default connect(
  (state, ownProps) => {
    const { numberOfReviews: count, averageRating: averageRate } = state.reviews.summary;

    let reviewStats = null;
    if (count && averageRate) {
      reviewStats = { count, averageRate };
    }

    return {
      ...ownProps,
      userRatedProduct: !!get(state, 'reviews.summary.customerReview', false),
      isModalVisible: get(state, 'reviews.isModalVisible', false),
      isLoggedIn: isUserLoggedIn(state.user),
      reviewStats,
    };
  }, {
    setModalVisibility,
  }
)(Title);
